import {AfterViewInit, ChangeDetectionStrategy, ChangeDetectorRef, Component, NgZone} from '@angular/core';
import { signUp, signIn } from 'aws-amplify/auth';
import {UserService} from "../../../../../packages/fe/core/user.service";
import { appTitle} from "../nav";
import {environment} from "../../environments/environment";
import {AmplifyAuthenticatorModule, AuthenticatorService} from '@aws-amplify/ui-angular';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
  imports: [AmplifyAuthenticatorModule],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class LoginComponent implements AfterViewInit {
  public appTitle = appTitle;

  services = {
    handleSignIn: async (input: any) => {
      // Force the entire async call and its resolution into the Zone
      return await this.zone.run(async () => {
        try {
          return await signIn(input);
        } catch (error) {
          // Re-throwing inside zone.run ensures the Authenticator
          // state machine catches the error within Angular's view
          this.cdr.markForCheck()
          throw error;
        }
      });
    }
  };

  constructor(private userService: UserService,
              private cdr: ChangeDetectorRef,
              private zone: NgZone,
              public authenticator: AuthenticatorService) {
    if(environment.test) { console.debug(this.services); }
    // Manually tell Angular to check for changes when the auth state moves
    this.authenticator.subscribe(() => {
      this.cdr.markForCheck();
    });
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.cdr.markForCheck()
    });
  }

  logout(): void {
    this.userService.logout();
    this.cdr.markForCheck();
  }

}
